<template lang="pug">
  //- combo drug
  div.drug-panel
    div.drug-panel--head
      button.btn.btn-info.icon-right(@click="createForm = true") 新增套藥
      CreateSpecialMedicineForm(v-if="createForm" v-on:closeForm="closeForm" :medicineType="'combo'" v-on:dataCreated="dataCreated")
    vuetable(
      ref="vuetableCombo"
      :track-by="'id'"
      :api-mode="false"
      :fields="comboField"
      pagination-path=""
      :css="boostrapCss"
      detail-row-component="combo-detail"
      @vuetable:cell-clicked="onComboClicked"
      item-actions="itemActions"
    )
      template(slot="actions" slot-scope="props")
        button.btn.btn-danger.btn-sm(@click="deleteCombo(props.rowData)") 刪除套藥
</template>


<script>
import Vue from 'vue';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import ComboDetail from './ComboDetail';
import CreateSpecialMedicineForm from '../../common/CreateSpecialMedicineForm';

Vue.component('combo-detail', ComboDetail);

export default {
  name: 'DrugDBSettings',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      comboField: [
        {
          name: 'medication.generic_name',
          title: '套藥名稱',
        },
        {
          name: 'pairsCount',
          title: '數量',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '動作',
          titleClass: 'text-center w-25',
          dataClass: 'text-center',
        },
      ],
      itemActions: [
        {
          name: 'delete-combo',
          label: '刪除套藥',
          icon: 'glyphicon glyphicon-zoom-in',
          class: 'btn btn-info',
          extra: { title: 'View' },
        },
      ],
      server,
      comboSet: {},
      createForm: false,
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
    CreateSpecialMedicineForm,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  async created() {
    await this.getComboDrugCategory();
    await this.getComboSet();
  },
  methods: {
    async dataCreated() {
      this.closeForm();
      await this.getComboDrugCategory();
      await this.getComboSet();
    },
    closeForm() {
      this.createForm = false;
    },
    getComboDrugCategory() {
      this.comboSet = {};
      return this.instance.get('/api/medication/', {
        params: {
          type: 'combo',
        },
      })
      .then((res) => {
        res.data.results.forEach((medication) => {
          this.comboSet[medication.id] = {
            medication,
            combo: [],
            pairsCount: 0,
            id: medication.id,
          };
        });
      });
    },
    onComboClicked(data, field, event) {
      this.$refs.vuetableCombo.toggleDetailRow(data.id);
    },
    getComboSet() {
      return this.instance.get('/api/combo-medication-set/')
      .then((res) => {
        res.data.forEach((pair) => {
          try {
            const oneSet = this.comboSet[pair.parent_medication.id];
            oneSet.combo.push(
              { medication: pair.child_medication, dose: pair.child_medication_quantity, relation_id: pair.id },
            );
            oneSet.pairsCount += 1;
          } catch (e) {
            console.error(e);
          }
        });
        this.$refs.vuetableCombo.setData(Object.values(this.comboSet));
      });
    },
    deleteCombo(data) {
      return this.instance.delete(`/api/medication/${data.id}/`)
      .then(async (res) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
        await this.getComboDrugCategory();
        await this.getComboSet();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ComboSettings.vue?63c37b73